/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Observable } from 'rxjs';
import { BaseApi } from './BaseApi';

export class UniversalTrackerScheduleApi extends BaseApi {
  endPoint: string = '/api/admin/universal-tracker-schedules';

  public findByIdExtended(id: any): Observable<any> {
    const _routeParams = {
      id: id,
      extended: true,
    };
    return this._get(this.endPoint + '/:id', _routeParams);
  }
}
